<template>
  <h1 class="t t-xl m-bx4">Choose profile banner</h1>
  <donut-img-radio-group
    v-model="bannerId"
    class="radio-group"
    aspect-ratio="231 / 36"
    input-name="profile-banner"
    :images="bannersPaths"
  />

  <donut-modal-sections-actions
    :show-cancel="true"
    cancel-text="Close"
    save-action="userProfileFields/updateBanner"
    :save-args="{bannerId}"
    :loading-on-save="true"
    :save-tracking="{
      eventName: 'User Profiles - Saved Profile Banner Edit',
      properties: { bannerId },
    }"
    :cancel-tracking="{
      eventName: 'User Profiles - Closed Profile Banner Edit Modal',
      properties: { bannerId },
    }"
  />
</template>

<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';

const { state } = useStore();
const bannersPaths = computed(() => state.modal.data.bannersPaths);
const value = computed(() => state.modal.data.value);
const bannerId = ref(value.value);
</script>

<style scoped>
.radio-group {
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(2, 1fr);
}
</style>
